// This class contains the necessary method of gathering plan data for the revocable form
// getFormMappings() would return an array of FoxIt fields with the corresponding value
import { FormMapping } from './FormMapping'
import { DateTime } from 'luxon'

export default class RevocableAssignmentForm extends FormMapping {
	constructor(planHolderId: string) {
		super(planHolderId)
	}

	getFormMappings() {
		return [
			...this.getProposedInsuredMapping(),
			...this.getPolicyOwnerMapping(),
			...this.getFuneralHomeMapping(),
			...this.getRepresentativeSignatureDateMappings(),
		]
	}
}
